import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import WorkCard from "@/components/feature/WorkCard";
import type { WorkItem } from "@/mocks/works";

interface WorkShowcaseProps {
  items: WorkItem[];
}

export default function WorkShowcase({ items }: WorkShowcaseProps) {
  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="Filmography"
          title="影视作品推荐"
          description="从电影到电视剧，精选佐佐木明希的重点作品，进入详情页查看剧情概要、角色介绍与更多剧照。"
          action={
            <Link
              to="/works"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-label font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              全部作品
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          }
        />

        {items.length === 0 ? (
          <div className="rounded-lg border border-dashed border-background-300 bg-background-50 py-16 text-center">
            <i className="ri-film-line text-3xl text-foreground-400" aria-hidden="true" />
            <p className="mt-3 text-sm text-foreground-500">暂无影视作品</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {items.map((item) => (
              <WorkCard key={item.id} item={item} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}